import { Component, OnInit, Input, HostBinding, HostListener, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'alg-switch',
  templateUrl: './alg-switch.component.html',
  styleUrls: ['./alg-switch.component.scss']
})
export class AlgSwitchComponent implements OnInit, OnChanges {
  @Input() name: string;
  @Input() @HostBinding('class.active') value: boolean = false;
  @Input() disable: boolean;
  @Output() change: EventEmitter<boolean> = new EventEmitter();
  public innerValue: string = '';

  public idInput: string;

  public switchValue: string;

  constructor() { }

  ngOnInit() {
    this.idInput = `input-${this.name}`;
  }

  @HostListener('click') toggle() {
    if(!this.disable){
      this.value = ! this.value;
      this.change.emit(this.value);
    }
  }
  ngOnChanges (changes: SimpleChanges): void {
    if (changes.name) {
      this.idInput = `input-${changes.name.currentValue}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/alg-switch/alg-switch.component.ts